import { useQuery, useQueryClient } from "@tanstack/react-query";
import { api } from "./api";
import { useMutationToast } from "../hooks/useMutationToast";

export type DlqStatus = "pending" | "retried" | "discarded";

export interface DlqMessage {
  id: string;
  queue_name: string;
  // null for `resume-job-process` and `career-process` rows — those queue
  // bodies don't carry a runId. Only the per-company `resume-job-checks`
  // rows do.
  run_id: string | null;
  company_id: string;
  company_name: string | null;
  attempts: number;
  error: string | null;
  first_seen_at: number;
  status: DlqStatus;
  resolved_at: number | null;
}

export function useDlq(status: DlqStatus = "pending") {
  return useQuery({
    queryKey: ["dlq", status],
    queryFn: () =>
      api<{ messages: DlqMessage[] }>(`/api/dlq?status=${status}`),
  });
}

export function useDlqAction(action: "retry" | "discard") {
  const qc = useQueryClient();
  return useMutationToast<{ ok: true; status: DlqStatus }, Error, string>({
    mutationFn: (id: string) =>
      api(`/api/dlq/${id}/${action}`, { method: "POST" }),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ["dlq"] });
    },
    success: action === "retry" ? "Message retried." : "Message discarded.",
    errorPrefix: action === "retry" ? "Retry failed" : "Discard failed",
  });
}
